import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import useUserInfo from "../data/useUserInfo";
import useAdminStructures from "../data/useAdminStructures";

const MainNav = (): JSX.Element => {
  const userInfo = useUserInfo();
  const userAdminStructures = useAdminStructures();
  return (
    <>
      <Navbar bg="primary" variant="dark" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Link to="/">
            <img
              src="https://static.da-io.net/images/da-logo.png"
              alt="DA logo"
              height="38"
            />
          </Link>
          <LinkContainer to="/">
            <Navbar.Brand className="text-light">
              Campaign Dashboard
            </Navbar.Brand>
          </LinkContainer>
          <Nav className="w-100">
            {/* <LinkContainer to='/'><Nav.Link className="text-white">Home</Nav.Link></LinkContainer> */}
            {userAdminStructures != null && userAdminStructures.length > 0 && (
              <Nav.Item>
                <LinkContainer className="text-white" to="/admin">
                  <Nav.Link>Admin</Nav.Link>
                </LinkContainer>
              </Nav.Item>
            )}
            <Nav.Item>
              <Nav.Link
                className="text-white"
                href="https://campaign-manager.voteda.org/"
                target="_blank"
              >
                Campaign Manager
              </Nav.Link>
            </Nav.Item>
            {userInfo != null && (
              <>
                <Nav.Item className="ml-auto">
                  <Nav.Link className="text-white" disabled>
                    Logged in as {userInfo.firstname} {userInfo.surname}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="text-white"
                    href="https://login.voteda.org/logout"
                  >
                    Logout
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};
export default MainNav;
